import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { TextService } from '../../../db-text/text.service';
import { HealthService } from '../../../shared/services/health.service';

@Component({
    selector: 'app-registrar-admin-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
    mayEditTextComponents: boolean;
    constructor(public health: HealthService, private textService: TextService) {
        this.textService.mayEditAny().subscribe({
            next: (v) => {
                this.mayEditTextComponents = v?.status === 200;
            },
            error: (e) => {
                //
            }
        });
    }
    environment: any = environment;

    ngOnInit(): void {
        //
    }
}
